<template>
    <v-container>
        <h1 class="titulo mb-3">Cadastro de Unidades de Negócio</h1>
        <v-card class="card">
            <v-card-text>
                <v-form ref="formUnidade" @submit.prevent="sendUnidadeNegocio">
                    <v-row>
                        <v-text-field
                                style="display:none"
                                v-model="form_data.id_registro"
                        />
                        <v-col cols="6">
                            <DynamicSelect label="Flavor:"
                                           id="FlavorSelect"
                                           v-model="form_data.id_flavor"
                                           placeholder="Selecione a marca"
                                           endpoint="/dynamic-selects/flavors/id"
                                           :multiple="false"
                                           :rules="[$rules.required]"
                                           item-text="label"
                                           item-value="id"
                            />
                        </v-col>
                        <v-col cols="6">
                            <DynamicSelect label="Empresa:"
                                           id="EmpresaSelect"
                                           v-model="form_data.id_empresa"
                                           placeholder="Selecione a empresa"
                                           endpoint="/dynamic-selects/empresas/id"
                                           :multiple="false"
                                           :rules="[$rules.required]"
                                           item-text="label"
                                           item-value="id"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                                    label="ID da Unidade de Negócio:"
                                    placeholder="Informe o ID da unidade de negócio"
                                    class="required"
                                    outlined
                                    v-model="form_data.id_unidade_negocio"
                                    :rules="[$rules.required]"
                                    v-input-filter="[$filters.numeric]"
                                    maxlength="10" />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                    label="Código da Unidade de Negócio:"
                                    placeholder="Informe o código da unidade de negócio"
                                    class="required"
                                    outlined
                                    v-model="form_data.cd_unidade_negocio"
                                    :rules="[$rules.required]"
                                    v-input-filter="[$filters.numeric]"
                                    maxlength="6" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                                    label="Nome da Unidade de Negócio:"
                                    placeholder="Informe o nome da unidade de negócio"
                                    class="required"
                                    outlined
                                    v-model="form_data.nm_unidade_negocio"
                                    :rules="[$rules.required]"
                                    maxlength="500" />
                        </v-col>
                        <v-col cols="6">
                            <HintMessage
                                    style="max-width: 400px;"
                                    class="mt-8 mb-5"
                                    title="DICA PARA CONFIGURAÇÃO"
                                    icon="mdi-lightbulb-on-outline"
                                    icon-color="secondary"
                                    description="Não se esqueça de cadastrar a unidade de negócio para todas as empresas que utilizarão a mesma!" />
                        </v-col>
                    </v-row>
                    <v-row class="justify-end">
                        <v-btn class="transition mr-4" color="secondary" type="reset" @click="resetForm">Limpar</v-btn>
                        <v-btn class="transition mr-4" color="primary" type="submit">Salvar</v-btn>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
  import { get } from 'lodash'
  import { AlertTypes } from '../../../plugins/alerts_types'
  import { notification } from '../../../plugins/helpers'
  export default {
    name: 'FormularioCadastroUnidadesNegocio',
    props: {
      unidadeEdicao: {
        type: Object,
        default: null
      }
    },
    data () {
      return {
        form_data: {
          id_registro: null,
          id_flavor: null,
          id_empresa: null,
          id_unidade_negocio: null,
          cd_unidade_negocio: null,
          nm_unidade_negocio: null
        }
      }
    },
    computed: {
      unidadeParaEditar: {
        get () {
          return this.unidadeEdicao
        },
        set (val) {
          this.$emit('input', val)
        }
      }
    },
    watch: {
      unidadeParaEditar (unidade) {
        if (unidade && unidade.id_registro) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
          this.form_data = {
            id_registro: unidade.id_registro,
            id_flavor: unidade.id_flavor,
            id_empresa: unidade.id_empresa,
            id_unidade_negocio: unidade.id_unidade_negocio,
            cd_unidade_negocio: unidade.cd_unidade_negocio,
            nm_unidade_negocio: unidade.nm_unidade_negocio
          }
        }
      }
    },
    methods: {
      resetForm () {
        this.resetEdicao()
        this.$refs.formUnidade.reset()
      },
      resetEdicao () {
        this.$emit('resetEdicao')
      },
      async sendUnidadeNegocio () {
        if (!this.$refs.formUnidade.validate()) {
          return
        }
        const edicao = (this.unidadeEdicao && this.unidadeEdicao.id_registro > 0)
        await this.$http.post('/painel/unidades_negocio', { ...this.form_data }).then((response) => {
          notification(AlertTypes.SUCCESS, `${edicao ? 'Unidade' : 'Nova unidade'} de negócio ${edicao ? 'atualizada' : 'cadastrada'} com sucesso!`)
          this.$emit('registroInserido')
          this.resetForm()
        }).catch((err) => {
          const status_code = get(err, 'response.status', 500)
          if (status_code === 422) {
            notification(AlertTypes.ERROR, err)
            return
          }
          if (edicao) {
            notification(AlertTypes.ERROR, 'Tivemos um erro ao atualizar a unidade de negócio, sugerimos tentar novamente e se o problema persistir entre em contato com a Área de Suporte!')
          } else {
            notification(AlertTypes.ERROR, 'Foi encontrado um erro ao finalizar o cadastro, tente novamente e caso o problema persista, entre em contato com a Área de Suporte.')
          }
        })
      }
    }
  }
</script>
